<template>
    <div class="indexPage">
        <div class="page page0">
            <div class="bg"></div>
            <div class="logo"></div>
            <div class="texts">
                <div class="txt0">生于赛场 暗藏锋芒</div>
                <div class="txt1">一汽奥迪 <span class="en">RS</span> 旗舰双车限量登场<br />尽在奥迪</div>
            </div>
        </div>
        <div class="page page1">
            <div class="content content_0">
                <div class="bg"></div>
                <div class="txt0"></div>
                <div class="txt1">
                    <div class="num">00</div>
                </div>
                <div class="txt2">中国限量<span class="en">66</span>台 全球限量<span class="en">660</span>台</div>
            </div>
            <div class="content content_1">
                <div class="bg"></div>
                <div class="center">
                    <div class="txt0"></div>
                    <div class="txt1"></div>
                </div>
            </div>
        </div>
        <div class="page page2">
            <div class="bg"></div>
            <Yuyue0 v-if="dealer" :cartype="''"></Yuyue0>
            <Yuyue1 v-else :cartype="''"></Yuyue1>
        </div>

        <div class="page page3">
            <div class="content0" @click="toGt()">
                <div class="bg"></div>
                <div class="con">
                    <div class="logo"></div>
                    <div class="line"></div>
                    <div class="text" >
                        <span>生于赛场，暗藏锋芒</span>
                        <div class="arrow"></div>
                    </div>
                </div>
            </div>
            <div class="content1" @click="toQ8()">
                <div class="bg"></div>
                <div class="con">
                    <div class="logo"></div>
                    <div class="line"></div>
                    <div class="text" >
                        <span>生于赛场，暗藏锋芒</span>
                        <div class="arrow"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sleep, isWeiXin, isIos, getQueryString, isPhoneNumber, calcSize } from '../utils/index'
import Yuyue0 from './components/yuyue_0.vue'
import Yuyue1 from './components/yuyue_1.vue'

var lenis = null
var controller = null
var controller2 = null
var controller3 = null
var controllerDefault = null
var controller5 = null
export default {
    components: { Yuyue0, Yuyue1 },
    data() {
        return {
            dealer: '',
            activity: ''
        }
    },
    created() {
        this.dealer = getQueryString('dealer')
        this.activity = getQueryString('activity')
    },
    mounted() {
        this.bindEvents()
    },
    beforeDestroy() {
        lenis.destroy()
        controller.destroy()
        controller2.destroy()
        controller3.destroy()
        controllerDefault.destroy()
        controller5.destroy()
        TweenMax.killTweensOf('*')
        console.log('清除动画')
    },
    destroyed() {},
    methods: {
        bindEvents() {
            $(window).scrollTop(0)

            controller = new ScrollMagic.Controller({
                globalSceneOptions: { offset: -$(window).innerHeight() / 2, reverse: true }
            })

            controller2 = new ScrollMagic.Controller({
                globalSceneOptions: { offset: -$(window).innerHeight() / 2, duration: '200%' }
            })
            controller3 = new ScrollMagic.Controller({
                globalSceneOptions: { triggerHook: 'onEnter', duration: '100%' }
            })
            controllerDefault = new ScrollMagic.Controller({})
            controller5 = new ScrollMagic.Controller({
                globalSceneOptions: { offset: '50%', duration: '100%' }
            })
            setTimeout(() => {
                this.bindPage0()
                this.bindPage1()
                this.bindPage2()
                this.bindPage3()
                // this.bindSwiper()
                this.bindLenis()
                // this.listenerPageLeaveline()
            }, 500)
        },
        bindLenis() {
            lenis = new Lenis({
                duration: 2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
                direction: 'vertical', // vertical, horizontal
                gestureDirection: 'vertical', // vertical, horizontal, both
                smooth: true,
                mouseMultiplier: 1,
                smoothTouch: false,
                touchMultiplier: 2,
                infinite: false
            })
            lenis.on('scroll', (e) => {
                // controller.update(true);
                // controller2.update(true);
                // controller3.update(true);
                // controllerDefault.update(true);
                // console.log(e)
            })
            lenis.resize()
            function raf(time) {
                lenis.raf(time)
                requestAnimationFrame(raf)
            }
            requestAnimationFrame(raf)
        },
        bindPage0() {
            var that = this
            TweenMax.set('.page0 .logo', { opacity: 0, x: calcSize(532), y: calcSize(280), width: calcSize(529), height: calcSize(211) })
            TweenMax.set('.page0 .texts .txt0', { opacity: 0, x: calcSize(300) })
            TweenMax.set('.page0 .texts .txt1', { opacity: 0, x: calcSize(300) })
            TweenMax.set('.page0 .bg', { opacity: 0.4, scale: 1, y: 0 })

            TweenMax.to('.page0 .logo', 0.5, { opacity: 1, delay: 0.2 })

            var anim = new TimelineMax()
            anim.to('.page0 .logo', 2, { x: 0, y: 0, width: calcSize(131), height: calcSize(48) })
            anim.to('.page0 .txt0', 1, { opacity: 1, x: 0 }, 1.3)
            anim.to('.page0 .txt1', 1, { opacity: 1, x: 0 }, 1.7)
            anim.to('.page0 .bg', 2, { opacity: 1, scale: 1.5, y: '-20%' }, 0)
            new ScrollMagic.Scene({ triggerElement: '.page0', triggerHook: 'onLeave', duration: '100%' })
                .setPin('.page0')
                .setTween(anim)
                .addTo(controllerDefault)
                .on('start', function () {
                    console.log('page0 start')
                })
                .on('enter', function () {
                    console.log('page0 enter')
                    that.resetPage1()
                })
                .on('leave', () => {
                    console.log('page0 leave')
                })
        },
        resetPage1() {
            TweenMax.set('.page1 .content_0 .txt0', { opacity: 0, x: '-50%', y: calcSize(-300) })
            TweenMax.set('.page1 .content_0  .txt1', { opacity: 0, x: '-20%', y: calcSize(-30) })
            TweenMax.set('.page1 .content_0 .txt2', { opacity: 0, x: '-50%', y: calcSize(300) })
            TweenMax.set('.page1 .content_1 .txt0', { opacity: 0, y: calcSize(100) })
            TweenMax.set('.page1 .content_1  .txt1', { opacity: 0, y: calcSize(100) })
            TweenMax.set('.page1 .content_1', { display: 'none', x: '100vw' })
            TweenMax.killTweensOf('.page1 .txt0')
            TweenMax.killTweensOf('.page1 .txt1')
            TweenMax.killTweensOf('.page1 .txt2')
            TweenMax.killTweensOf('.page1 .num')
            this.page1NumEnd = false
        },
        bindPage1() {
            var that = this
            this.resetPage1()

            var anim = new TimelineMax()
            anim.to('.page1', 2, {
                onStart: () => {
                    var line = new TimelineMax()
                    line.to('.page1 .content_0 .txt0', 1, { opacity: 1, x: '-50%', y: calcSize(-163) }, 0)
                    line.to(
                        '.page1 .content_0  .txt1',
                        0.5,
                        {
                            opacity: 1,
                            x: '-50%',
                            y: calcSize(-30),
                            onComplete: () => {
                                if (that.page1NumEnd) return
                                that.page1NumEnd = true
                                var tween = TweenMax.to('.page1 .content_0  .num', 1, {
                                    ease: Linear.easeNone,
                                    onUpdate: () => {
                                        var p = tween.progress()
                                        var num = parseInt(Math.ceil(p * 66))
                                        if (num < 10) num = '0' + num
                                        $('.page1  .content_0 .num').text(num)
                                    }
                                })
                            }
                        },
                        0
                    )
                    line.to('.page1  .content_0 .txt2', 1, { opacity: 1, x: '-50%', y: calcSize(128) }, 0)
                }
            })
            anim.to('.page1', 2, {
                onStart: () => {
                    TweenMax.to('.page1  .content_1', 1, { x: 0, display: 'block' })
                    TweenMax.to('.page1  .content_1 .txt0', 0.5, { opacity: 1, y: 0, delay: 1 })
                    TweenMax.to('.page1  .content_1 .txt1', 0.5, { opacity: 1, y: 0, delay: 1.2 })
                }
            })
            anim.to('.page1', 2, {})

            new ScrollMagic.Scene({ triggerElement: '.page1', triggerHook: 'onLeave', duration: '200%' })
                .setPin('.page1')
                .setTween(anim)
                .addTo(controllerDefault)
                .on('start', () => {
                    console.log('page1 start')
                })
                .on('enter', function () {
                    console.log('page1 enter') 
                    that.resetPage2();
                })
                .on('leave', () => {
                    console.log('page1 leave')
                })
        },
        resetPage2() {
            TweenMax.set('.page2 .bg', { y: '-20%' })
            TweenMax.set('.page2 .drive_div', { opacity: 0, y: '100%' })
            // TweenMax.killTweensOf('.page2 .bg')
            // TweenMax.killTweensOf('.page2 .drive_div')
        },
        bindPage2() {
            var that = this
            that.resetPage2()
            var anim = new TimelineMax()
            anim.to('.page2 .bg', 1, { y: '-42%' })
            anim.to('.page2 .drive_div', 1, { opacity: 1, y: '0%' }, 0)
            anim.to('.page2 .bg', 1, {})
            new ScrollMagic.Scene({ triggerElement: '.page2', triggerHook: 'onLeave', duration: '100%' })
                .setTween(anim)
                .setPin('.page2')
                .addTo(controllerDefault)
                .on('start', () => {
                    console.log('page2 start')
                })
                .on('enter', function () {
                    console.log('page2 enter')
                    that.resetPage3()
                })
                .on('leave', () => {
                    console.log('page2 leave')
                })
        },
        resetPage3() {},
        bindPage3() {
            var that = this
            that.resetPage3()
        },
        toGt() {
            this.$router.push('/indexb')
            try{
                stm_clicki('send', 'event', 'RS', '点击', 'RS 6 Avant GT',1);
            }catch(e){
                
            }
        },
        toQ8() {
            this.$router.push('/indexa')
            try{
                stm_clicki('send', 'event', 'RS', '点击', 'RS Q8 quattro 45周年纪念版',1);
            }catch(e){
                
            }
        }
    }
}
</script>

<style scoped lang="scss">
.indexPage {
    position: relative;
    width: 100%;
    background: #000;
    color: #fff;
    .page {
        width: 100%;
        height: 100vh;
        background-color: #000;
        position: relative;
        left: 0;
        top: 0;
        overflow: hidden;
    }
    .page0 {
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/index/page0_bg.jpg) no-repeat center center;
            background-size: cover;
            background-origin: center bottom;
            opacity: 0.4;
            position: absolute;
            left: 0;
            top: 0;
            transform: translateY(0%);
        }
        .logo {
            background: url(../assets/index/logo.svg) no-repeat center center;
            background-size: contain;
            position: absolute;
            left: 147px;
            top: 124px;
            width: 131px;
            height: 48px;
            transform: translateX(532px) translateY(280px);
            width: 529px;
            height: 211px;
            z-index: 3;
            opacity: 0;
        }
        .texts {
            position: absolute;
            left: 147px;
            top: 196px;
            width: 700px;
            z-index: 3;
            .txt0 {
                font-size: 64px;
                line-height: 77px;
                font-family: 'audi-zh-bold';
                opacity: 0;
                transform: translateX(300px);
            }
            .txt1 {
                margin-top: 10px;
                font-size: 24px;
                line-height: 32px;
                font-family: 'audi-zh-medium';
                opacity: 0;
                transform: translateX(300px);
                .en {
                    font-family: 'audi_bold_4.03';
                }
            }
        }
    }

    .page1 {
        .content {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            &.content_0 { 
                .bg {
                    width: 100%;
                    height: 100%;
                    background: url(../assets/gif/gif1.gif) no-repeat center center;
                    background-size: cover;
                }
                .txt0 {
                    position: absolute;
                    z-index: 2;
                    width: 412px;
                    height: 48px;
                    background: url(../assets/index/gt_logo.png) no-repeat center center;
                    background-size: contain;
                    left: 50%;
                    top: 50%;
                    transform: translateX(-50%) translateY(-163px);
                }
                .txt1 {
                    position: absolute;
                    z-index: 2;
                    width: 706px;
                    height: 109px;
                    background: url(../assets/index/page1_txt2.png) no-repeat center center;
                    background-size: contain;
                    left: 50%;
                    top: 50%;
                    transform: translateX(-50%) translateY(-30px);
                    .num {
                        font-size: 140px;
                        line-height: 109px;
                        font-family: 'audi_extended_bold_4.03';
                        position: absolute;
                        left: 0;
                        top: 0;
                    }
                }
                .txt2 {
                    position: absolute;
                    z-index: 2;
                    text-align: center;
                    width: 100%;
                    font-size: 32px;
                    line-height: 39px;
                    font-family: 'audi-wide';
                    .en {
                        font-family: 'audi_normal_4.03';
                    }
                    left: 50%;
                    top: 50%;
                    transform: translateX(-50%) translateY(128px);
                }
            }
            &.content_1 {
                display: none;
                z-index:10;
                .bg {
                    width: 100%;
                    height: 100%;
                    background:#000 url(../assets/index/page1_bg2.jpg) no-repeat center center;
                    background-size: cover;
                }
                .center {
                    position: absolute;
                    z-index: 2;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 0;
                    width: 100%;
                    text-align: center;
                    .txt0 {
                        width: 687px;
                        height: 48px;
                        background: url(../assets/index/quattro_logo.png) no-repeat center center;
                        background-size: contain;
                        margin: 0 auto;
                    }
                    .txt1 {
                        margin-top: 40px;
                        width: 581px;
                        height: 219px;
                        background: url(../assets/index/page1_txt4.png) no-repeat center center;
                        background-size: contain;
                        margin: 0 auto;
                    }
                }
            }
        }
    }
    .page2 {
        .bg {
            width: 100%;
            height: 120vw;
            background: url(../assets/index/page2_bg.jpg) no-repeat left top;
            background-size: 100% auto;
            position: absolute;
            left: 0;
            top: 0;
            transform: translateY(-30%);
        }
        .drive_div {
            transform: translateY(100%);
        }
        .drive_div0 {
            width: 100%;
            height: 583px;
            position: absolute;
            z-index: 3;
            background-color: rgba(0, 0, 0, 0.85);
            left: 0;
            bottom: 0;
            .mapbox {
                width: 1019px;
                height: 456px;
                position: absolute;
                left: 108px;
                top: 65px;
                overflow: hidden;
                background-color: #fff;
            }
            .driver_info {
                box-sizing: border-box;
                padding: 30px 20px;
                width: 310px;
                min-height: 355px;
                position: absolute;
                left: 902px;
                top: 142px;
                overflow: hidden;
                z-index: 3;
                background-color: #000;
                .img {
                    width: 270px;
                    height: 150px;
                    left: 20px;
                    top: 30px;
                    display: block;
                    object-fit: cover;
                }
                .title {
                    font-size: 18px;
                    line-height: 22px;
                    margin-top: 24px;
                }
                .name {
                    font-size: 18px;
                    line-height: 22px;
                    margin-top: 20px;
                }
                .gps {
                    width: 32px;
                    height: 32px;
                    background: url(../assets/index/page2_gps.svg) no-repeat center center;
                    background-size: contain;
                    margin-top: 20px;
                }
            }
            .form_box {
                width: 448px;
                position: absolute;
                left: 1326px;
                top: 52px;
                .ipt {
                    font-size: 18px;
                    line-height: 35px;
                    margin-top: 10px;
                    position: relative;
                    option {
                        background-color: rgba(0, 0, 0, 0.8);
                        color: #fff;
                        font-size: 18px;
                    }
                }
                .form-item {
                    position: relative;
                    padding-top: 10px;
                    .iptbox {
                        border-bottom: 1px solid #383838;
                        position: relative;
                        &.sltbox {
                            padding-right: 20px;
                        }
                    }
                    .label {
                        font-size: 18px;
                        line-height: 22px;
                    }
                    .error {
                        height: 25px;
                        font-size: 12px;
                        line-height: 22px;
                        color: #d20630;
                        padding-top: 5px;
                    }
                    .arrow {
                        display: block;
                        width: 12px;
                        height: 12px;
                        background: url(../assets/index/page2_arrow.svg) no-repeat center center;
                        background-size: contain;
                        position: absolute;
                        z-index: 2;
                        right: 5px;
                        top: 24px;
                    }
                    .iptcar {
                        font-size: 24px;
                        font-family: 'audi_extended_bold_4.03';
                    }
                    .checkbox {
                        height: 26px;
                        background: url(../assets/index/page2_echeck.svg) no-repeat left center;
                        background-size: contain;
                        font-size: 18px;
                        line-height: 26px;
                        padding-left: 34px;
                        position: relative;
                        cursor: pointer;
                        &.checked {
                            &::before {
                                content: ' ';
                                height: 30px;
                                width: 30px;
                                background: url(../assets/index/page2_echeck_on.svg) no-repeat left center;
                                background-size: contain;
                                position: absolute;
                                left: -2px;
                                top: -4px;
                                z-index: 2;
                            }
                        }
                    }
                }
                .form-footer {
                    padding-top: 30px;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    .btn {
                        width: 224px;
                        height: 53px;
                        cursor: pointer;
                        font-size: 18px;
                        line-height: 53px;
                        text-align: center;
                        background: url(../assets/index/page2_btn1.png) no-repeat center center;
                        background-size: contain;
                        &:hover {
                            background: url(../assets/index/page2_btn2.png) no-repeat center center;
                            background-size: contain;
                        }
                    }
                }
            }
        }

        .drive_div1 {
            width: 100%;
            height: 583px;
            position: absolute;
            z-index: 3;
            background-color: rgba(0, 0, 0, 0.85);
            left: 0;
            bottom: 0;
            .form_box {
                width: 838px;
                margin: 0 auto;
                padding-top: 40px;
                .form-row {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    &.form-row2 {
                        width: 48%;
                    }
                }

                .ipt {
                    font-size: 18px;
                    line-height: 35px;
                    margin-top: 10px;
                    position: relative;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: keep-all;
                    white-space: nowrap;
                    option {
                        background-color: rgba(0, 0, 0, 0.8);
                        color: #fff;
                        font-size: 18px;
                    }
                }

                .form-item {
                    width: 48%;
                    position: relative;
                    padding-top: 20px;
                    &.w100 {
                        width: 100%;
                        .arrow {
                            right: 400px;
                        }
                    }
                    .label {
                        font-size: 18px;
                        line-height: 22px;
                    }
                    .iptbox {
                        border-bottom: 1px solid #383838;
                        position: relative;
                        &.sltbox {
                            padding-right: 20px;
                        }
                    }
                    .error {
                        height: 25px;
                        font-size: 12px;
                        line-height: 22px;
                        color: #d20630;
                        padding-top: 5px;
                    }
                    .arrow {
                        display: block;
                        width: 12px;
                        height: 12px;
                        background: url(../assets/index/page2_arrow.svg) no-repeat center center;
                        background-size: contain;
                        position: absolute;
                        opacity: 0.5;
                        z-index: 2;
                        right: 5px;
                        top: 24px;
                    }
                    .iptcar {
                        font-size: 24px;
                        font-family: 'audi_extended_bold_4.03';
                    }
                    .checkbox {
                        height: 26px;
                        background: url(../assets/index/page2_echeck.svg) no-repeat left center;
                        background-size: contain;
                        font-size: 18px;
                        line-height: 26px;
                        padding-left: 34px;
                        position: relative;
                        cursor: pointer;
                        &.checked {
                            &::before {
                                content: ' ';
                                height: 30px;
                                width: 30px;
                                background: url(../assets/index/page2_echeck_on.svg) no-repeat left center;
                                background-size: contain;
                                position: absolute;
                                left: -2px;
                                top: -4px;
                                z-index: 2;
                            }
                        }
                    }
                }
                .form-footer {
                    padding-top: 30px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    .btn {
                        width: 224px;
                        height: 53px;
                        cursor: pointer;
                        font-size: 18px;
                        line-height: 53px;
                        text-align: center;
                        background: url(../assets/index/page2_btn1.png) no-repeat center center;
                        background-size: contain;
                        &:hover {
                            background: url(../assets/index/page2_btn2.png) no-repeat center center;
                            background-size: contain;
                        }
                    }
                }
            }
        }
    }

    .page3 {
        background-color: #fff;
        .content0 {
            width: 100%;
            height: 50vh;
            position: relative;
            &:hover {
                .bg {
                    opacity: 1;
                }
                .con {
                    .logo {
                        filter: grayscale(0%);
                        left: 810px;
                    }
                    .line {
                        opacity: 1;
                    }
                    .text {
                        opacity: 1;
                        transform: translateY(0px);
                    }
                }
            }
            .bg {
                width: 100%;
                height: 100%;
                background: url(../assets/index/page3_bg0.jpg) no-repeat center center;
                background-size: cover;
                opacity: 0;
                transition: 0.5s all;
            }
            .con {
                position: absolute;
                width: 100%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                z-index: 4;
                .logo {
                    position: relative;
                    left: 810px;
                    width: 412px;
                    height: 48px;
                    background: url(../assets/index/gt_logo.png) no-repeat center center;
                    background-size: contain;
                    filter: grayscale(100%);
                    left: 128px;
                    transition: 0.5s all;
                }
                .line {
                    position: relative;
                    left: 810px;
                    margin-top: 35px;
                    margin-bottom: 35px;
                    width: 782px;
                    height: 2px;
                    background: url(../assets/index/page3_line0.png) no-repeat left top;
                    background-size: 100% 100%;
                    opacity: 0;
                    transition: 0.5s all;
                }
                .text {
                    position: relative;
                    left: 810px;
                    font-size: 64px;
                    line-height: 77px;
                    font-family: 'DFPKingGothicGBMedium';
                    height: 77px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    opacity: 0;
                    transition: 0.5s all;
                    transform: translateY(100px);
                    cursor: pointer;
                    .arrow {
                        width: 60px;
                        height: 60px;
                        background: url(../assets/index/page3_arrow.png) no-repeat center center;
                        background-size: contain;
                        margin-left: 100px;
                        margin-top: 8px;
                        cursor: pointer;
                    }
                }
            }
        }
        .content1 {
            width: 100%;
            height: 50vh;
            position: relative;
            &:hover {
                .bg {
                    opacity: 1;
                }
                .con {
                    .logo {
                        filter: grayscale(0%);
                    }
                    .line {
                        opacity: 1;
                    }
                    .text {
                        opacity: 1;
                        transform: translateY(0px);
                    }
                }
            }
            .bg {
                width: 100%;
                height: 100%;
                background: url(../assets/index/page3_bg1.jpg) no-repeat center center;
                background-size: cover;
                opacity: 0;
                transition: 0.5s all;
            }
            .con {
                position: absolute;
                left: 0px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 4;
                .logo {
                    position: relative;
                    left: 125px;
                    width: 687px;
                    height: 48px;
                    background: url(../assets/index/quattro_logo.png) no-repeat center center;
                    background-size: contain;
                    filter: grayscale(100%);
                    transition: 0.5s all;
                }
                .line {
                    position: relative;
                    left: 125px;
                    margin-top: 35px;
                    margin-bottom: 35px;
                    width: 782px;
                    height: 2px;
                    background: url(../assets/index/page3_line.png) no-repeat left top;
                    background-size: 100% 100%;
                    opacity: 0;
                    transition: 0.5s all;
                }
                .text {
                    position: relative;
                    left: 125px;
                    font-size: 64px;
                    line-height: 77px;
                    font-family: 'DFPKingGothicGBMedium';
                    height: 77px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    opacity: 0;
                    transition: 0.5s all;
                    transform: translateY(100px);
                    cursor: pointer;
                    .arrow {
                        width: 60px;
                        height: 60px;
                        background: url(../assets/index/page3_arrow.png) no-repeat center center;
                        background-size: contain;
                        margin-left: 140px;
                        margin-top: 8px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
</style>
